import type { ReactNode } from 'react';

import styles from './page.module.css';

type Props = {
  title: string;
  children: ReactNode;
};

export function Page(props: Props) {
  const { children, title } = props;

  return (
    <div className={styles.root}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.card}>{children}</div>
    </div>
  );
}
